import { SLIPPAGE_TORELANCE } from '../constants'

export function applySlippageTorelance(price: number, isLong: boolean) {
  if (isLong) {
    return (price * (1000 + SLIPPAGE_TORELANCE)) / 1000
  } else {
    return (price * (1000 - SLIPPAGE_TORELANCE)) / 1000
  }
}
